import { Outlet, useLocation } from "react-router";
import { SidebarProvider, SidebarTrigger } from "@/components/ui/sidebar";
// import { Trademark } from "@/components/trademark";
import { Sidebar } from "./sidebar";
import { usePostHog } from "posthog-js/react";
import { useEffect } from "react";
import { useUserDetails } from "@/hooks";

const Layout = () => {
  const posthog = usePostHog();
  const location = useLocation();
  const { data: userDetails, isSuccess } = useUserDetails();

  useEffect(() => {
    if (isSuccess) {
      if (userDetails && userDetails?.type === "anonymous") {
        posthog.identify(userDetails?.details);
      } else if (userDetails) {
        posthog.identify(userDetails?.details?.id, { ...userDetails.details });
      }
    }
  }, [userDetails, isSuccess, posthog]);

  useEffect(() => {
    posthog.capture("$pageview", { $current_url: location.pathname });
  }, [location, posthog]);

  return (
    <SidebarProvider>
      <Sidebar />
      <div className="min-h-screen w-screen bg-sidebar flex flex-col justify-start items-center md:pt-2">
        <nav className="md:hidden flex items-start justify-start w-full px-2 h-8">
          <SidebarTrigger className="hover:bg-sidebar-accent focus:bg-sidebar-accent" />
        </nav>
        <main className="w-full h-full flex bg-background items-start justify-center p-4 md:rounded-tl-lg border border-sidebar-border">
          <div className="max-w-[1024px] w-full">
            <Outlet />
          </div>
        </main>
      </div>
    </SidebarProvider>
  );
};

export default Layout;
